import { cn } from '@liza/ui/utils/cn';
import { CarePlanSectionIcon } from './carePlanSectionIcon';
import type { CarePlanSection } from './carePlanSections';

export type CarePlanSectionHeadingProps = {
  section: CarePlanSection;
  className?: string;
  /** `h4` where the section heads a genuine list, `span` where it sits inside another paragraph. */
  as?: 'p' | 'h4' | 'span';
  children: React.ReactNode;
};

/** A section heading on a topic card: the section's icon, then its name. */
export function CarePlanSectionHeading({
  section,
  className,
  as: Tag = 'p',
  children,
}: CarePlanSectionHeadingProps): React.ReactElement {
  return (
    <Tag className={cn('flex items-center gap-1.5 text-sm text-muted-foreground', className)}>
      <CarePlanSectionIcon section={section} />
      {children}
    </Tag>
  );
}
